import React from 'react';
import Section from '../../../elements/Section';
import Title from '../../../elements/Title';
import Content from '../../../elements/Content';
import Link from '../../../components/Link';
import List, { ListItem } from '../../../elements/List';
import { classes, LINKS } from '../utils';

export default function ArticlesOfAssociation() {
  return (
    <Section>
      <Title>Articles of Association</Title>
      <Content>
        Please find below the Articles of Association as of January 31st, 2018
        in Dutch and a free translation in French:
      </Content>
      <List>
        <ListItem>
          <Link href={LINKS.articlesOfIncorporationNL}>
            Articles of Incorporation (Dutch)
          </Link>
        </ListItem>
        <ListItem>
          <Link href={LINKS.articlesOfIncorporationFR}>
            Articles of Incorporation (French)
          </Link>
        </ListItem>
      </List>
    </Section>
  );
}
